if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderWrapper = this.querySelector('.swiper');
        this.sliderThumbsWrapper = this.querySelector(
          '.swiper.product__thumbs',
        );
        this.thumbsScrollbarWrapper = this.querySelector(
          '.swiper.product__thumbs .swiper-scrollbar',
        );

        this.init();
        if (!this.slider) return;

        this.layoutObserver = new MutationObserver(() => {
          const vertical =
            document.documentElement.classList.contains('gallery-variant-a');
          if (vertical === this.verticalThumbs) return;
          const activeIndex = this.slider.activeIndex;
          this.slider.destroy(true, true);
          this.sliderThumbs?.destroy(true, true);
          this.init(activeIndex);
        });
        this.layoutObserver.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['class'],
        });
        this.sizeObserver = new ResizeObserver(() => {
          this.sliderThumbs?.update();
        });
        this.sizeObserver.observe(this.sliderWrapper);
      }

      disconnectedCallback() {
        this.layoutObserver?.disconnect();
        this.sizeObserver?.disconnect();
        this.slider?.destroy(true, true);
        this.sliderThumbs?.destroy(true, true);
      }

      init(activeIndex = 0) {
        if (!this.sliderWrapper) return;

        this.verticalThumbs =
          document.documentElement.classList.contains('gallery-variant-a');
        this.sliderThumbs = this.sliderThumbsWrapper
          ? new Swiper(this.sliderThumbsWrapper, {
              watchSlidesProgress: true,
              on: {
                init: (swiper) => this.updateThumbsFade(swiper),
                progress: (swiper) => this.updateThumbsFade(swiper),
                lock: (swiper) => this.updateThumbsFade(swiper),
                unlock: (swiper) => this.updateThumbsFade(swiper),
                update: (swiper) => this.updateThumbsFade(swiper),
              },
              scrollbar: {
                el: this.thumbsScrollbarWrapper,
                draggable: true,
              },
              direction: this.verticalThumbs ? 'vertical' : 'horizontal',
              slidesPerView: this.verticalThumbs ? 'auto' : 4,
              spaceBetween: this.verticalThumbs ? 8 : 14,
              breakpoints: this.verticalThumbs
                ? {
                    750: { spaceBetween: 12 },
                  }
                : {
                    375: {
                      slidesPerView: 5,
                    },
                    990: {
                      slidesPerView: 6,
                    },
                    1280: {
                      slidesPerView: 7,
                    },
                    1440: {
                      slidesPerView: 8,
                    },
                  },
            })
          : null;
        this.slider = new Swiper(this.sliderWrapper, {
          initialSlide: activeIndex,
          navigation: {
            enabled: this.verticalThumbs,
            prevEl: this.querySelector('.product__gallery-prev'),
            nextEl: this.querySelector('.product__gallery-next'),
          },
          thumbs: {
            swiper: this.sliderThumbs,
          },
          autoHeight: true,
          spaceBetween: 8,
          scrollbar: {
            el: this.sliderWrapper.querySelector('.swiper-scrollbar'),
            draggable: true,
          },
        });
      }

      updateThumbsFade(swiper) {
        swiper.el.classList.toggle(
          'product__thumbs-has-more',
          this.verticalThumbs && !swiper.isEnd && !swiper.isLocked,
        );
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      setActiveMedia(mediaId) {
        const media = this.querySelector(`[data-media-id="${mediaId}"]`);

        if (!media) return;

        this.slider.slideTo(Number(media.dataset.mediaIndex));
      }
    },
  );
}
